<template>
  <label :for="id" class="raft-checkbox" @click="toggle">
    <input
      type="checkbox"
      :value="fieldValue"
      @change="toggle"
      :aria-label="label"
      :data-cy="cy"
    />
    <div :class="checkedStatus">
      <span />
    </div>
    <span class="checkbox-label" :class="isLabelHidden ? 'hidden' : ''">{{
      label
    }}</span>
    <slot name="custom-checkbox-content" />
  </label>
</template>
<script>
export default {
  name: "VCheckbox",
  props: {
    fieldValue: { type: Boolean, required: false },
    label: { type: String, default: "" },
    isLabelHidden: { type: Boolean, required: false },
    cy: { type: String, default: "" },
    required: { type: Boolean, required: false },
    name: { type: String, default: "" },
    id: { type: String, default: "" },
    size: { type: String, default: "" },
    disabled: { type: Boolean, required: false },
  },
  computed: {
    checkedStatus() {
      switch (this.fieldValue) {
        case true:
          return "checked";
        case false:
          return "";
        default:
          return "indeterminate";
      }
    },
  },
  methods: {
    toggle() {
      this.$emit("input", !this.fieldValue);
    },
  },
};
</script>

<style scoped>
:root {
  --disabled-text: #757575;
  --primary-light: #5f6a78;
  --primary-dark: #253446;
}

.raft-checkbox {
  display: flex;
  align-items: center;
  min-height: 1.5rem;
  gap: 0.25rem;
  padding-left: 1rem;
  position: relative;
  font-size: 14px;
  font-weight: 500;
}

label input {
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
}

label:hover {
  cursor: pointer;
}

label.hidden {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

label div {
  border: 0.0625rem solid var(--disabled-text, gray);
  border-radius: 0.125rem;
  display: inline-block;
  left: 0.25rem;
  position: absolute;
  top: calc(50% - 0.5rem);
}

label div:hover {
  border-color: var(--primary-light, navy);
}

label div > span {
  border-radius: 0.125rem;
  display: block;
  height: 0.5rem;
  width: 0.5rem;
  margin: 0.1875rem;
}

label div.indeterminate {
  border-color: var(--primary-dark, navy);
  padding-bottom: 0.1875rem;
  padding-top: 0.1875rem;
}

label div.indeterminate > span {
  background-color: var(--primary-dark, navy);
  height: 0.125rem;
}

label div.checked {
  border-color: var(--primary-dark, navy);
}

label div.checked > span {
  background-color: var(--primary-dark, navy);
}
</style>
